import {
    Box,
    Card,
    CardBody,
    Stack
} from "@chakra-ui/react";

import { useEffect, useRef, useState } from "react";

const ResourceWorkshopCard = ({
  description,
  backgroundImage = null,
  setSelectedResource,
  resourceData,
  toggleView,
}) => {
  const [fontSize, setFontSize] = useState(17);
  const textRef = useRef(null);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (textRef.current) {
        const lines = textRef.current.clientHeight / parseInt(fontSize);
        if (lines > 3) {
          setFontSize((prev) => Math.max(prev - 1, 13));
        }
      }
    });

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => observer.disconnect();
  }, [description, fontSize]);

  return (
    <Stack width="100%" p="0px" fontFamily="lato">
      <Card
        width="100%"
        borderRadius="20px"
        height="100%"
        cursor="pointer"
        transition="all 0.2s ease"
        _hover={{
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
          transform: "translateY(-4px)",
        }}
        onClick={() => {
          setSelectedResource(resourceData);
          toggleView(true);
        }}
      >
        <CardBody p="0px" height="100%" display="flex" flexDirection="column">
          <Box
            width="100%"
            aspectRatio={16 / 9}
            borderRadius="10px"
            position="relative"
            backgroundImage={backgroundImage || "url('/resource-frame.png')"}
            backgroundSize="102% 102%"
            backgroundRepeat="no-repeat"
            backgroundPosition="center 25%"
            p={0}
          />
        </CardBody>
      </Card>
    </Stack>
  );
};

export default ResourceWorkshopCard;
